import {
    setCookie,
    initializeMap,
    initMenuTrigger,
    initOpenInNewTab,
    aosConfig,
    addScollClass,
    addParalax,
    addFancyboxFixForGallery,
    addCloseCookies,
    initForm,
    googleMapInit,
    initLoadNews,
    faqService
} from './functions';


import gsap from "gsap";


const mainApp = () => {



    // init menu trigger
    initMenuTrigger();

    // init open in new tab
    initOpenInNewTab();

    // init AOS animation config
    aosConfig();

    // add scroll class to body  
    addScollClass('0px', 'scroll');

    // add paralax to element
    addParalax('.paralax');



    //fix gallery id for slideshow
    addFancyboxFixForGallery('.blocks-gallery-grid');

    // add close function to cookies
    addCloseCookies();



    //start - contact form
    initForm();

    googleMapInit();


    initLoadNews();

    faqService();


}

document.addEventListener("DOMContentLoaded", mainApp, false);


(function ($) {
    const mainAppWithJquery = () => {

        $('.subpageHeader__country').mouseover(function () {
            const alias = $(this).data('alias');
            $('.subpageHeader__map .active').removeClass('active');
            $('.subpageHeader__map #e_' + alias).addClass('active');
        });
        $('.subpageHeader__country').mouseout(function () {
            $('.subpageHeader__map .active').removeClass('active');

        });

        $('.eCountry').mouseover(function () {
            const alias = $(this).attr('id').replace('e_', '');
            $('.subpageHeader__country.active').removeClass('active');
            $('.subpageHeader__country[data-alias="' + alias + '"').addClass('active');
        });
        $('.eCountry').mouseout(function () {
            $('.subpageHeader__country.active').removeClass('active');
        });





        $('.footerO__slider').slick({
            infinite: true,
            arrows: true,
            dots: false,
            autoplay: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            speed: 700,
            autoplaySpeed: 5000,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                    }
                }, {
                    breakpoint: 560,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ]
        });
        $('.gFleet').slick({
            infinite: false,
            arrows: true,
            dots: false,
            autoplay: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            speed: 700,
            autoplaySpeed: 5000,
            responsive: [
                {
                    breakpoint: 769,
                    settings: {
                        slidesToShow: 2,
                    }
                }, {
                    breakpoint: 560,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ]
        });






        if ($('.footer1__slider').length > 0) {
            $('.footer1__slider').slick({
                infinite: true,
                arrows: false,
                dots: false,
                autoplay: true,
                speed: 5000,
                autoplaySpeed: 0,//gfdnb
                variableWidth: true,
                cssEase: 'linear',
                //centerMode: true,

            });
        }



        //fancybox
        $(".blocks-gallery-item a, .fancybox, .wp-block-image a").fancybox({
            'loop': true,
            'margin': [44, 0],
            'gutter': 50,
            'keyboard': true,
            'arrows': true,
            'infobar': false,
            'toolbar': true,
            'buttons': ["slideShow", "fullScreen", "close"],
            'idleTime': 4,
            'protect': false,
            'modal': false,
            'animationEffect': "fade",
            'animationDuration': 600,
            'transitionEffect': "fade",
            'transitionDuration': 800,
            backFocus: false,
            thumbs: {
                autoStart: true, // Display thumbnails on opening
                hideOnClose: true, // Hide thumbnail grid when closing animation starts
                parentEl: ".fancybox-container", // Container is injected into this element
                axis: "y" // Vertical (y) or horizontal (x) scrolling
            }
        });



    };
    document.addEventListener("DOMContentLoaded", mainAppWithJquery, false);

})(jQuery);



